import axios from "axios";
import moment from "moment";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { BsFillChatTextFill } from "react-icons/bs";
import { MdOutlineClose } from "react-icons/md";
import { api_url, AXIOS_HEADER } from "../../constants/data";
import { useSelector } from "react-redux";
import debounce from "lodash/debounce";

// Optimized ChatInput Component
const ChatInput = React.memo(({ onSend }) => {
    const inputRef = useRef();

    const handleSend = () => {
        const value = inputRef.current.value.trim();
        if (value.length === 0) return;
        onSend(value);
        inputRef.current.value = ""; // Clear the input field after sending
    };

    return (
        <div className="send_message">
            <input
                type="text"
                placeholder="დაწერეთ მესიჯი..."
                ref={inputRef}
            />
            <div className="send_btn" onClick={handleSend}>
                <img src="/icons/sent.png" alt="" />
            </div>
        </div>
    );
});

export default function Chat() {
    const [isVisible, setIsVisible] = useState(false);
    const [showChat, setShowChat] = useState(true);
    const [chat, setChat] = useState([]);
    const userState = useSelector(state => state.auth.user);
    const chatWrapperRef = useRef(null);

    const [width, setWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => setWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    // Fetch Chat Data
    const refetchChat = useCallback(() => {
        axios.post(`${api_url}/chat`, {}, AXIOS_HEADER)
            .then(res => {
                setChat(res.data);
            });
    }, []);

    useEffect(() => {
        if(width < 768) {
            disableChat();
        }else{
            toggleChat()
        }
    }, [width])

    useEffect(() => {
        refetchChat();
    }, [])

    useEffect(() => {
        const interval = setInterval(() => {
            refetchChat();
        }, 10000);

        return () => {
            clearInterval(interval);
        };
    }, [refetchChat]);

    const toggleChat = () => {
        setShowChat(true);
        setIsVisible(true);
    };

    const disableChat = () => {
        setIsVisible(false);

        setShowChat(false);
    };


    useEffect(() => {
        if (chatWrapperRef.current) {
            chatWrapperRef.current.scrollTop = chatWrapperRef.current.scrollHeight;
        }
    }, [chat, showChat]);

    // Send Message
    const addMessage = (message) => {
        axios.post(`${api_url}/add-message`, { body: message }, AXIOS_HEADER)
            .then(() => {
                refetchChat();
            });
    };

    return (
        <>
            {showChat && (
                <section id="chat" className={`chat_component ${!isVisible ? "show_chat" : ""}`}>
                    <h3>საინფორმაციო ჩათი</h3>
                    <button className="disable-chat" onClick={disableChat}>
                        <MdOutlineClose />
                    </button>

                    <div className="chat_wrapper" ref={chatWrapperRef}>
                        {chat.length > 0 &&
                            chat.slice().reverse().map((item, index) => (
                                <div className={`chat_item ${item.user_id === userState?.id ? 'sender' : ''}`} key={index}>
                                    <div className="chat_user">
                                        <img src={item.user.image} alt="" />
                                    </div>
                                    <div className="chat_box">
                                        <p>{item.body}</p>
                                        <p className="chat_date">
                                            {item.user.name} {item.user.lastname},{" "}
                                            {moment(item.created_at).format("YYYY-MM-DD HH:mm:ss")}
                                        </p>
                                    </div>
                                </div>
                            ))}
                    </div>

                    <ChatInput onSend={addMessage} />
                </section>
            )}

            <button className="showchat-button" onClick={toggleChat}>
                <BsFillChatTextFill />
                <p>საინფორმაციო ჩათი</p>
            </button>
        </>
    );
}
